import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState } from 'store';
import { JobsInitialState } from 'types/reducers/jobs';
import { ResumeBuilder } from 'types/reducers/resumeBuilder';
import { UserState } from 'types/reducers/user';

export interface ReducerState extends RootState {
  jobs: JobsInitialState;
  user: UserState;
  resumeBuilder: ResumeBuilder;
}

export const useAppDispatch = () => useDispatch();

export const useAppSelector: TypedUseSelectorHook<ReducerState> = useSelector;
